import {h, Component} from 'preact';
import DateTime from '/chat/src/common/js/lib/DateTime';
import lang from '/chat/src/languages/lang';
import style from './style.scss'
import {UserModel, TicketModel} from '/chat/src/redux/model'
import Customization from '/chat/src/redux/model/customization/model';
import {connect} from 'preact-redux';
import TextDisplay from '/chat/src/components/TextDisplay'


class AutoresponseMetaMessage extends Component{
    constructor(props){
        super(props)
        this.state = {
            inputHover: false,
            buttonHover: false,
            value: props.user.email,
        }
        this.renderEmailField = this.renderEmailField.bind(this)
        this.renderEmailExist = this.renderEmailExist.bind(this)
        this.renderEmailNotExist = this.renderEmailNotExist.bind(this)
        this.confirmReplyByEmail = this.confirmReplyByEmail.bind(this)
    }

    confirmReplyByEmail(){
        this.props.dispatch(TicketModel.responseToAutoresponse({
                'email': this.state.value,
                'reply_by_email': true
            } ,this.props.entry.id
        ))
    }

    renderEmailField(text, onClick){
        const entry = this.props.entry;
        const meta = entry.meta;
        const active = this.state.value || this.state.inputHover;
        return (
            <div className={style.MetaAutoResponse} >
                {text}
                <input
                    type='text'
                    style = {
                        active && {
                            border: '1px solid',
                            color: this.props.color
                        }
                    }
                    onMouseEnter={()=>this.setState({inputHover: true})}
                    onMouseLeave={()=>this.setState({inputHover: false})}
                    placeholder='Email'
                    value={this.state.value}
                    onInput={event =>this.setState({value: event.target.value})}
                    onKeypress={
                        event => {
                            if (event.keyCode === 13){
                                onClick()
                            }
                        }
                    }
                />
                {onClick && (
                    <div
                        onClick={onClick}
                        className={style.MetaAutoResponseSendButton}>
                        <img
                            style={ active &&{
                                backgroundColor: this.props.color
                            }}
                        src='/common/assets/images/ClientChat_Icon_Send.png'/>
                    </div>
                )}
            </div>
        )
    }
    renderInactiveField(text, email){
        return (
            <div className={style.MetaAutoResponse} >
                {text}
                <input
                    type='text'
                    style = {{
                        border: '1px solid lightgrey',
                        color: 'grey'
                    }}
                    value={email}
                    disabled
                />
            </div>
        )
    }
    renderEmailNotExist(responded, respond_data){
        const text = this.props.language.get("AutoresponseEmailRequest")
        if(responded){
            return (
                <div>
                    {this.renderInactiveField(text, respond_data.email)}
                    <div
                        className='meta-message' >
                        {this.props.language.get("AutoresponseCustomerReplyByEmail")}
                    </div>
                </div>
            )
        }
        return this.renderEmailField(text, ()=>{
            this.confirmReplyByEmail();
        })
    }
    renderEmailExist(responded, respond_data){
        const text = this.props.language.get("AutoresponseEmailSendConfirm")

        let emailField;

        if(responded){
            return (
            <div>
                {this.renderInactiveField(text, respond_data.email)}
                <div
                    className={style.MetaAutoResponseSendConfirmButtonDisable} >

                    {this.props.language.get("YesPleaseSendEmail")}
                </div>
                <div
                    className={'meta-message'} >
                    {this.props.language.get("AutoresponseCustomerReplyByEmail")}
                </div>
            </div>
        )
        }else{
            return (
            <div>
                {this.renderEmailField(text, () => {
                    this.confirmReplyByEmail();})
                }
                <div
                    style={ this.state.buttonHover &&!responded &&{
                        backgroundColor: this.props.color,
                        color: 'white',
                    }}
                    onClick={ () => {
                        this.confirmReplyByEmail();
                    }}
                    onMouseEnter={()=>this.setState({buttonHover: true})}
                    onMouseLeave={()=>this.setState({buttonHover: false})}
                    className={style.MetaAutoResponseSendConfirmButton} >
                    {this.props.language.get("YesPleaseSendEmail")}
                </div>
            </div>
            )
        }
    }
    render(){
        const entry = this.props.entry;
        const meta = entry.meta;
        const responded = meta.details.responded;
        const respond_data = meta.details.respond_data;

        switch(meta.details.type){
            case 'email_exist':
                return this.renderEmailExist(responded, respond_data)
            case 'email_not_exist':
                return this.renderEmailNotExist(responded, respond_data)
            default:
                return null;
        }
    }
}

export default connect(
    state => {
        return {
        language: Customization.getLanguage(state),
        color: Customization.getColor(state),
        room: TicketModel.getCurrentRoom(state)
}})(AutoresponseMetaMessage)



// WEBPACK FOOTER //
// ./routes/Chat/Chat/MetaMessage/Autoresponse.js